/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface ClearAllCachesRequest {
    sessionId: string;
}

export interface GetCacheStatistics1Request {
    sessionId: string;
}

export interface InvalidateRoleCacheRequest {
    roleId: string;
    tenantId: string;
    sessionId: string;
}

export interface InvalidateTenantCacheRequest {
    tenantId: string;
    sessionId: string;
}

export interface InvalidateUserCacheRequest {
    userId: string;
    tenantId: string;
    sessionId: string;
}

/**
 * PermissionCacheApi - interface
 * 
 * @export
 * @interface PermissionCacheApiInterface
 */
export interface PermissionCacheApiInterface {
    /**
     * Clears all cached permissions (use with caution)
     * @summary Clear all permission caches
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionCacheApiInterface
     */
    clearAllCachesRaw(requestParameters: ClearAllCachesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clears all cached permissions (use with caution)
     * Clear all permission caches
     */
    clearAllCaches(requestParameters: ClearAllCachesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves performance statistics for the permission cache system
     * @summary Get permission cache statistics
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionCacheApiInterface
     */
    getCacheStatistics1Raw(requestParameters: GetCacheStatistics1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves performance statistics for the permission cache system
     * Get permission cache statistics
     */
    getCacheStatistics1(requestParameters: GetCacheStatistics1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Invalidates all cached permissions for a specific role in a tenant
     * @summary Invalidate role permission cache
     * @param {string} roleId 
     * @param {string} tenantId 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionCacheApiInterface
     */
    invalidateRoleCacheRaw(requestParameters: InvalidateRoleCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Invalidates all cached permissions for a specific role in a tenant
     * Invalidate role permission cache
     */
    invalidateRoleCache(requestParameters: InvalidateRoleCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Invalidates all cached permissions for a specific tenant
     * @summary Invalidate tenant permission cache
     * @param {string} tenantId 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionCacheApiInterface
     */
    invalidateTenantCacheRaw(requestParameters: InvalidateTenantCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Invalidates all cached permissions for a specific tenant
     * Invalidate tenant permission cache
     */
    invalidateTenantCache(requestParameters: InvalidateTenantCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Invalidates all cached permissions for a specific user in a tenant
     * @summary Invalidate user permission cache
     * @param {string} userId 
     * @param {string} tenantId 
     * @param {string} sessionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionCacheApiInterface
     */
    invalidateUserCacheRaw(requestParameters: InvalidateUserCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Invalidates all cached permissions for a specific user in a tenant
     * Invalidate user permission cache
     */
    invalidateUserCache(requestParameters: InvalidateUserCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class PermissionCacheApi extends runtime.BaseAPI implements PermissionCacheApiInterface {

    /**
     * Clears all cached permissions (use with caution)
     * Clear all permission caches
     */
    async clearAllCachesRaw(requestParameters: ClearAllCachesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling clearAllCaches().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permission-cache/clear`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears all cached permissions (use with caution)
     * Clear all permission caches
     */
    async clearAllCaches(requestParameters: ClearAllCachesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearAllCachesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves performance statistics for the permission cache system
     * Get permission cache statistics
     */
    async getCacheStatistics1Raw(requestParameters: GetCacheStatistics1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getCacheStatistics1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permission-cache/statistics`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves performance statistics for the permission cache system
     * Get permission cache statistics
     */
    async getCacheStatistics1(requestParameters: GetCacheStatistics1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCacheStatistics1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidates all cached permissions for a specific role in a tenant
     * Invalidate role permission cache
     */
    async invalidateRoleCacheRaw(requestParameters: InvalidateRoleCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling invalidateRoleCache().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling invalidateRoleCache().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling invalidateRoleCache().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permission-cache/invalidate/role/{roleId}/{tenantId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Invalidates all cached permissions for a specific role in a tenant
     * Invalidate role permission cache
     */
    async invalidateRoleCache(requestParameters: InvalidateRoleCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.invalidateRoleCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidates all cached permissions for a specific tenant
     * Invalidate tenant permission cache
     */
    async invalidateTenantCacheRaw(requestParameters: InvalidateTenantCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling invalidateTenantCache().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling invalidateTenantCache().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permission-cache/invalidate/tenant/{tenantId}`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Invalidates all cached permissions for a specific tenant
     * Invalidate tenant permission cache
     */
    async invalidateTenantCache(requestParameters: InvalidateTenantCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.invalidateTenantCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Invalidates all cached permissions for a specific user in a tenant
     * Invalidate user permission cache
     */
    async invalidateUserCacheRaw(requestParameters: InvalidateUserCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling invalidateUserCache().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling invalidateUserCache().'
            );
        }

        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling invalidateUserCache().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permission-cache/invalidate/{userId}/{tenantId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Invalidates all cached permissions for a specific user in a tenant
     * Invalidate user permission cache
     */
    async invalidateUserCache(requestParameters: InvalidateUserCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.invalidateUserCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
